import React from "react";

interface PDFViewerInterface {
  pdf_url: string;
}

const PDFViewer: React.FC<PDFViewerInterface> = ({ pdf_url }) => {
  return (
    <div style={{ width: "100%", height: "600px" }}>
      <iframe src={pdf_url} width="100%" height="100%" frameBorder="0" />
    </div>
  );
};

export default PDFViewer;
